"use strict"; // Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.sort.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uint32ArrayFrom = void 0; // IE 11 does not support Array.from, so we do it manually

function uint32ArrayFrom(a_lookUpTable) {
  if (!Array.from) {
    var return_array = new Uint32Array(a_lookUpTable.length);
    var a_index = 0;

    while (a_index < a_lookUpTable.length) {
      return_array[a_index] = a_lookUpTable[a_index];
    }

    return return_array;
  }

  return Uint32Array.from(a_lookUpTable);
}

exports.uint32ArrayFrom = uint32ArrayFrom;